import { Button, Stack, Typography, Link as MuiLink } from '@mui/material';
import { useNavigate, useParams, Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { MerchantCatalog } from 'src/app/api/openapi';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo, useRef } from 'react';
import { CatalogClient } from 'src/app/api/clients/catalogs';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const CatalogsTable = () => {
  const navigate = useNavigate();
  const { merchantId } = useParams();

  const cursor = useRef<string | undefined>(undefined);

  const dataSource = useMemo(
    () => ({
      getRows: () =>
        CatalogClient.listMerchantCatalogs(
          merchantId || '',
          'name',
          10,
          cursor.current
        ).then(({ data }) => {
          cursor.current = data.cursor;
          return {
            rows: data?.items || [],
          };
        }),
    }),
    []
  );

  const columns: GridColDef<MerchantCatalog>[] = [
    {
      field: 'name',
      headerName: 'Name',
      renderCell: ({ row }) => (
        <MuiLink component={Link} to={`./catalogs/${row.id}`}>
          {row.name}
        </MuiLink>
      ),
      flex: 2,
    },
    {
      field: 'availability_start',
      renderCell: ({ row }) =>
        row.availability_start
          ? dayjs(row.availability_start).format('MM-DD-YYYY')
          : '-',
      headerName: 'Availability Start',
      flex: 1,
    },
    {
      field: 'availability_end',
      renderCell: ({ row }) =>
        row.availability_end
          ? dayjs(row.availability_end).format('MM-DD-YYYY')
          : '-',
      headerName: 'Availability End',
      flex: 1,
    },
    {
      field: 'activated',
      renderCell: ({ row }) =>
        row.activated ? (
          'Active'
        ) : (
          <Button
            variant="outlined"
            onClick={() => navigate(`./catalogs/${row.id}/activate`)}
            sx={{ m: 0 }}
          >
            Activate
          </Button>
        ),
      headerName: 'Status',
      flex: 1,
    },
  ];

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h3">Catalogs</Typography>
        <Button variant="flat" onClick={() => navigate('./catalogs/create')}>
          Create Catalog
        </Button>
      </Stack>
      <Stack maxHeight="70vh">
        <CustomDataGrid
          dataSource={dataSource}
          columns={columns}
          rowCount={-1}
          lazyLoading
          lazyLoadingRequestThrottleMs={500}
          paginationModel={{ page: 0, pageSize: 10 }}
        />
      </Stack>
    </>
  );
};

export default CatalogsTable;
